import {
    DropdownData,
    InputType,
    Form,
    FormField,
    FormSection,
    FormType,
    ReactiveFormStableValueChange,
} from '@fitogest/reactive-form-builder/interfaces';
import {
  Component,
  ViewChild,
  ViewEncapsulation,
  OnInit,
  AfterViewInit,
  ElementRef,
} from '@angular/core';

import { ActivatedRoute, Router } from '@angular/router';


import { build, list, stack } from '@fitogest/reactive-form-builder/utils';
import { ReactiveFormBuilderComponent } from '@fitogest/reactive-form-builder';
import { LoginApiService } from 'src/app/service/api/login-api.service';
import { UserApiService } from 'src/app/service/api/user-api.service';
import { UsuariosApiService } from 'src/app/service/api/usuarios-api.service';
import { StorageManager } from 'src/app/common/storage-manager.class';
import { environment } from 'src/environments/environment';
import type { UserModel } from 'src/app/models/usuarios/user.model';
import { SiexApiService } from 'src/app/service/api/siex-api.service';

declare global {
  interface Window {
    gtag?: (...args: any[]) => void;
  }
}
@Component({
  selector: 'app-register',
  standalone: false,
  encapsulation: ViewEncapsulation.None,
  templateUrl: './register.component.html',
  styleUrls: ['./register.component.scss'],
})
export class RegisterComponent implements OnInit, AfterViewInit {
  // Optional; only declare if you will use it. Otherwise remove.
  @ViewChild('monthlySubscriptionButton', { static: false })
  monthlySubscriptionButton!: ElementRef;

  @ViewChild('annualSubscriptionButton', { static: false })
  annualSubscriptionButton!: ElementRef;

  @ViewChild(ReactiveFormBuilderComponent)
  private formBuilderRef?: ReactiveFormBuilderComponent<UserModel>;

  /** Users loaded from API (used to validate uniqueness) */
  public users: UserModel[] = [];

  public subscriptionStatus = 'guest';

  /** Client-side validation flags (used by template) */
  public errors = {
    usernameIsValid: true,
    emailIsValid: true,
  };

  /** Branding */
  public readonly logoUrl = environment.logoUrl;

  public readonly appName = environment.appName;

  /** UI state */
  public accountCreated = false;

  public reactiveForm!: { formType: FormType; model: Partial<UserModel>; formFields: Form<UserModel> };


  private externalDropdownsReadyPending = false;

  /** Model bound to the form-builder */
  public model = {} as UserModel;

  /** (Kept for compatibility with your form workflow) */

  /** Dropdown: tipo */
  public tipos: DropdownData<string> = list<string>(
    ['...', null],
    'Comunero',
    'Aplicador',
  );

  public comunidadesAutonomas: DropdownData<string> = list();

  /** Form-builder config: account data */
  public formFieldsAccount: FormField<any>[] = [
    {
        name: 'username',
        field: 'username',
        label: this.appName === 'agrogestSIEX' ? 'Email' : 'Nombre de usuario',
        input: { type: InputType.TEXT, isEditable: true },
        width: 3,
        conditions: { isRememberedOnDuplicate: true, isRequired: false, isRetained: false, hasUndoEnabled: false, isVisible: true },
        required: false,
        order: 1
    },
];

  public formFieldsPassword: FormField<any>[] = [
    {
        name: 'password',
        field: 'password',
        label: 'Contraseña',
        input: { type: InputType.PASSWORD, isEditable: true },
        width: 3,
        conditions: { isRememberedOnDuplicate: true, isRequired: false, isRetained: false, hasUndoEnabled: false, isVisible: true },
        required: false,
        order: 1
    },
    {
        name: 'password_repeat',
        field: 'password_repeat',
        label: 'Repita la contraseña',
        input: { type: InputType.PASSWORD, isEditable: true },
        width: 3,
        conditions: { isRememberedOnDuplicate: true, isRequired: false, isRetained: false, hasUndoEnabled: false, isVisible: true },
        required: false,
        order: 2
    },
];

  /** Form-builder config: personal data */
  public formFieldsLeft: FormField<any>[] = [
    {
        name: 'nombre',
        field: 'nombre',
        label: 'Nombre',
        input: { type: InputType.TEXT, isEditable: true },
        width: 3,
        conditions: { isRememberedOnDuplicate: true, isRequired: false, isRetained: false, hasUndoEnabled: false, isVisible: true },
        required: false,
        order: 1
    },
    {
        name: 'apellidos',
        field: 'apellidos',
        label: 'Apellidos',
        input: { type: InputType.TEXT, isEditable: true },
        width: 3,
        conditions: { isRememberedOnDuplicate: true, isRequired: false, isRetained: false, hasUndoEnabled: false, isVisible: true },
        required: false,
        order: 2
    },
    {
        name: 'codigo_ine',
        field: 'codigo_ine',
        label: 'Comunidad Autónoma',
        input: { type: InputType.DROPDOWN_SEARCH, isEditable: true, data: this.comunidadesAutonomas, dropdownConfiguration: { valuePrimaryKey: 'codigo_ine' }, optionLabel: 'label', optionValue: 'value' },
        width: 3,
        conditions: { isRememberedOnDuplicate: true, isRequired: false, isRetained: false, hasUndoEnabled: false, isVisible: true },
        required: false,        values: this.comunidadesAutonomas,

        order: 3
    },
    {
        name: 'email',
        field: 'email',
        label: 'Email',
        input: { type: InputType.TEXT, isEditable: true },
        width: 3,
        conditions: { isRememberedOnDuplicate: true, isRequired: false, isRetained: false, hasUndoEnabled: false, isVisible: Boolean(this.appName !== 'agrogestSIEX') },
        required: false,
        visible: this.appName !== 'agrogestSIEX',
        order: 4
    },
    {
        name: 'nif',
        field: 'nif',
        label: this.appName === 'agrogestSIEX' ? 'NIF/CIF' : 'NIF (para autónomos)',
        input: { type: InputType.TEXT, isEditable: true },
        width: 3,
        conditions: { isRememberedOnDuplicate: true, isRequired: false, isRetained: false, hasUndoEnabled: false, isVisible: true },
        required: false,
        order: 5
    },
    {
        name: 'cif',
        field: 'cif',
        label: 'CIF (para SL, SA, CB o similares)',
        input: { type: InputType.TEXT_MASK, isEditable: true, textMaskConfiguration: { mask: 'a-99999999' } },
        width: 3,
        conditions: { isRememberedOnDuplicate: true, isRequired: false, isRetained: false, hasUndoEnabled: false, isVisible: Boolean(this.appName !== 'agrogestSIEX') },
        required: false,
        visible: this.appName !== 'agrogestSIEX',
        order: 6
    },
    {
        name: 'telefono',
        field: 'telefono',
        label: 'Teléfono',
        input: { type: InputType.TEXT, isEditable: true },
        width: 3,
        conditions: { isRememberedOnDuplicate: true, isRequired: false, isRetained: false, hasUndoEnabled: false, isVisible: true },
        required: false,
        order: 7
    },
    {
        name: 'tipo',
        field: 'tipo',
        label: 'Tipo',
        input: { type: InputType.DROPDOWN, isEditable: true, data: this.tipos, optionLabel: 'label', optionValue: 'value' },
        width: 3,
        conditions: { isRememberedOnDuplicate: true, isRequired: false, isRetained: false, hasUndoEnabled: false, isVisible: Boolean(this.appName !== 'agrogestSIEX') },
        required: false,
        visible: this.appName !== 'agrogestSIEX',        values: this.tipos,

        order: 8
    },
];

  /** Fast lookup (O(1)) sets for username/email uniqueness checks */
  private usernameSet = new Set<string>();

  private emailSet = new Set<string>();

  // -------------------------------
  // Form & Validation
  // -------------------------------
  /**
   * Basic client-side validation
   * - Required fields
   * - Password equality
   * - Username & email flags (already set by stable field validation)
   */
  private readonly REQUIRED_FIELDS: Array<keyof UserModel> = [
    'username',
    'password',
    'nombre',
    'apellidos',
    'telefono',
    'codigo_ine',
  ];


  private createReactiveForm(): void {
    const formType = Number(FormType.CREATION) as FormType;
        this.reactiveForm = {
            formType,
            model: this.model,
            formFields: {
                name: 'register',
                header: 'Crear una cuenta',
                type: formType,
                sections: this.getReactiveSections(),
                table: null,
                uploadButton: { isEnabled: Boolean(false), label: '' },
                signed: Boolean(false),
            },
        };
  }

  private getReactiveSections(): FormSection<UserModel>[] {
        return [
            { name: 'Datos de la cuenta', fields: this.formFieldsAccount, width: 12, isVisible: true, order: 1 },
            { name: 'Contraseña', fields: this.formFieldsPassword, width: 12, isVisible: true, order: 2 },
            { name: 'Datos personales', fields: this.formFieldsLeft, width: 12, isVisible: true, order: 3 },
        ];
    }

  public stableValueChanges(event: ReactiveFormStableValueChange<UserModel>): void {
    this.model = { ...this.model, ...event.value } as UserModel;
    this.handleUserValueChange(String(event.changedField ?? ''));
  }

  constructor(
    private readonly router: Router,
    private readonly route: ActivatedRoute,
    public readonly loginApi: LoginApiService,
    public readonly userApi: UserApiService,
    public readonly usuariosApi: UsuariosApiService,
    public siexApi: SiexApiService,
  ) {
    void Router;
  }

  // -------------------------------
  // Google Ads Conversion
  // -------------------------------
  /**
   * Reports a conversion event to Google Ads when a user successfully registers
   */
  private gtag_report_conversion(): void {
    window.gtag?.('event', 'conversion', {
      send_to: 'AW-852919730/t0ZECNTi9M8bELKL2pYD',
      value: 1.0,
      currency: 'EUR',
    });
  }

  // -------------------------------
  // Lifecycle
  // -------------------------------
  async ngOnInit(): Promise<void> {
    this.initFormData();
    this.createReactiveForm();
    // Redirect if already logged in
    const currentUser = StorageManager.getUser();

    this.route.queryParamMap.subscribe((params) => {
      this.subscriptionStatus = params.get('estado') ?? '';
    });

    if (currentUser?.id && this.appName !== 'agrogestSIEX') {
      this.router.navigate(['dashboard']);
      return;
    }

    // Load users for uniqueness checks
    try {
      this.users = await this.usuariosApi.usuariosGET.toPromise();
      this.usernameSet = new Set(
        this.users
          .map((u) => (u.username ?? '').trim().toLowerCase())
          .filter(Boolean),
      );
      this.emailSet = new Set(
        this.users
          .map((u) => (u.email ?? '').trim().toLowerCase())
          .filter(Boolean),
      );
    } catch (e) {
      // Keep UI usable even if the list fails; just skip uniqueness checks
      // (You could toast a warning here if desired)
      // console.warn('Failed to load users for uniqueness checks', e);
    }
  }

  public ngAfterViewInit(): void {
    this.notifyExternalDropdownsReady();
  }

  // -------------------------------
  // Actions
  // -------------------------------
  async register(): Promise<void> {
    if (!this.validateForm()) {
      alert(
        'Por favor, rellene todos los campos obligatorios y/o asegúrese de que las contraseñas coincidan.',
      );
      return;
    }

    try {
      await this.loginApi.register(this.model);

      this.accountCreated = true;

      if (environment.appName === 'agrogestSIEX') {
        this.gtag_report_conversion();
        console.log('Function google ads');
      }

      const STRIPE_RENDERING_DELAY = 100;

      setTimeout(() => {
        const element = this.monthlySubscriptionButton.nativeElement;
        element.setAttribute('customer-email', this.model.username);

        const element2 = this.annualSubscriptionButton.nativeElement;
        element2.setAttribute('customer-email', this.model.username);
      }, STRIPE_RENDERING_DELAY);

      this.userApi.sendEmailConfirmation(this.model);

    } catch (e) {
      console.error('Error on register()', e);
      alert('No se ha podido completar el registro. Inténtelo de nuevo.');
    }
  }

  goBack(): void {
    this.router.navigate(['login']);
  }

  validateForm(): boolean {
    // 1) Required fields
    const hasAllRequired = this.REQUIRED_FIELDS.every((f) =>
      Boolean((this.model as any)[f]),
    );

    if (!hasAllRequired) {
      return false;
    }

    // 2) CIF/NIF normalization (your original rule)
    if (this.model.cif != null) {
      (this.model as any).nif = (this.model as any).cif;
    }
    delete (this.model as any).cif;

    // 3) Passwords match
    if ((this.model as any).password !== (this.model as any).password_repeat) {
      return false;
    }

    // 4) Uniqueness checks (flags are updated by stable field validation)
    if (!this.errors.emailIsValid || !this.errors.usernameIsValid) {
      return false;
    }

    return true;
  }

  /**
   * Handle incremental validations based on changed field.
   * Keeps O(1) lookups via sets and normalizes input.
   */
  private handleUserValueChange(tag: string): void {
    switch (tag) {
      case 'username': {
        const normalized = (this.model.username ?? '').trim().toLowerCase();
        const syntacticallyValid = this.isValidEmail(normalized);

        if (this.appName === 'agrogestSIEX') {
          this.errors.usernameIsValid =
            syntacticallyValid && !this.usernameSet.has(normalized);
        } else {
          this.errors.usernameIsValid =
            normalized.length > 0 && !this.usernameSet.has(normalized);
        }
        console.log(this.errors);
        break;
      }

      case 'email': {
        const normalized = (this.model.email ?? '').trim().toLowerCase();
        const syntacticallyValid = this.isValidEmail(normalized);

        this.errors.emailIsValid =
          syntacticallyValid && !this.emailSet.has(normalized);
        break;
      }

      case 'cif': {
        (this.model as any).nif = null;
        break;
      }

      case 'nif': {
        (this.model as any).cif = null;
        break;
      }

      default:
        break;
    }
  }

  public subscribe(): void {
    window.open(
      'https://buy.stripe.com/5kQfZigtnaqh520eVn8bS00?locale=es&prefilled_email=' +
        this.model.username,
    );
  }

  // -------------------------------
  // Utils
  // -------------------------------
  /** Minimal email validation (you can swap for a stronger regex if needed) */
  private isValidEmail(value: string): boolean {
    if (!value) {
      return false;
    }
    // Simple and fast: must contain "@" and ".", with non-space chars around
    const basic = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

    return basic.test(value);
  }

  private initFormData(): Promise<boolean> {
    this.resetExternalDropdowns();

    const builds = [
      build(
        this.siexApi.comunidadesAutonomasGET,
        this.comunidadesAutonomas,
        'descripcion',
        true,
      ),
    ];

    return stack(builds, () => {
      this.finalizeExternalDropdowns();
    });
  }

  private resetExternalDropdowns(): void {
    this.externalDropdownsReadyPending = false;
    this.formBuilderRef?.resetExternalDropdowns();
  }

  private finalizeExternalDropdowns(): void {
    this.externalDropdownsReadyPending = true;
    this.notifyExternalDropdownsReady();
  }

  private notifyExternalDropdownsReady(): void {
    setTimeout(() => {
      if (!this.externalDropdownsReadyPending) {
        return;
      }

      this.formBuilderRef?.finalizeExternalDropdowns();
      this.formBuilderRef?.refreshExternalDropdownMappings();
    });
  }
}
